import { Alert, Button, Container, Stack, Text, Title } from "@assetwatch/ui";

export function AppErrorFallback() {
  return (
    <Container size="sm">
      <Stack gap={16}>
        <Title size="lg">Unable to load Hardware</Title>
        <Text tone="subtle">Something went wrong while loading this app.</Text>
        <Alert tone="negative" title="Refresh the page and try again." />
        <Button onClick={() => window.location.reload()} variant="outline">
          Refresh
        </Button>
      </Stack>
    </Container>
  );
}
